let apidaePrestasMap = {

    props: {
        uri: String,
        query: String,
        lang: String,
        layoutMode: String
    },
    computed: {

    },
    components: {

    },
    directives: {

    },
    data() {
        return {
            zoom: 12,
            maxZoom: 17,
            center: [6.5111747, 43.3369947],
            geolocPosition: undefined,
            markers: [],
            markerMouseEvent: [6.5111747, 43.3369947],
            showMarkerMouseEvent: false,
            mapIconOn: apidae.asset_url + 'img/mapIcon/mapIconOn.png',
            mapIconOff: apidae.asset_url + 'img/mapIcon/mapIconOff.png',
            selectedFeatures: [],
            interactionOptions: {
                dragPan: true,
                onFocusOnly: true,
                shiftDragZoom: true,
                mouseWheelZoom: true,
                pinchZoom: true,
            },
            mapLock: false,
        }
    },
    methods: {
        styleFuncFactory () {
            // cache to allow styles reusing for features with same state
            let cache = {}
            // pre build some shared styles
            //  let blueStroke = new Stroke({color: "blue"})

            return (feature) => {
                // console.log(feature)
                const size = this.markers.length
                let style = cache[size]
                if (!style) {
                    style = new ol.style.Style({
                        image: new ol.style.Icon( /** @type {olx.style.IconOptions} */ ({
                            anchor: [0.5, 46],
                            anchorXUnits: 'fraction',
                            anchorYUnits: 'pixels',
                            src: this.mapIconOn
                        }))
                    });
                    cache[size] = style
                }
                return [style]
                
                // const size = feature.get('features').length
                // let style = cache[size]
                // if (!style) {
                //     style = createStyle({
                //         imageRadius: 10,
                //         strokeColor: '#fff',
                //         fillColor: '#3399cc',
                //         text: size.toString(),
                //         textFillColor: '#fff',
                //     })
                //     cache[size] = styles
                // }
                // return [style]

                // feature - ol.Feature instance
                // resolution - current view resolution as float
            
                // build styles based on feature state
                // let style = []
                // style function always return array of Style instances
                // return style 
            }
        },
        onMapMounted() {
            fetch(apidae.base_url + '/' + this.lang + "/" + this.uri + '/map?' + this.query)
            .then(stream => stream.json())
            .then(data => {
                this.markers = data.prestas.slice(0, 5000);
            })
            .then(() => {
                //https://jsfiddle.net/ghettovoice/br84dgq2/
                // console.log(this.markers);
                setTimeout(() => {
                    this.$refs.mapView.$view.fit(this.$refs.vectorSource.$source.getExtent(), {
                        size: this.$refs.map.$map.getSize(),
                        padding: [30, 30, 30, 30],
                        duration: 1000,
                    })
                }, 1000)
            })
            .then(() => {
                self = this

                //add marker on grid item hover
                let items = document.querySelectorAll('.grid__item')
                items.forEach(item => {
                    item.addEventListener('mouseenter', (e) => {
                        // console.log(item)
                    // jQuery(document.body).on('mouseenter mouseleave', '.grid__item', function(e) {
                        // var $this = jQuery(this);

                        //trace
                        ///     var urlPlan = $this.data('plan');
                        ///     if(!!urlPlan)
                        ///         e.type == 'mouseenter' ? addPolyline(urlPlan) : delPolyline(idxTrace);

                        //marker
                        var lat = e.target.dataset.latitude;
                        var long = e.target.dataset.longitude;
                        if (!!lat && !!long)
                            e.type == 'mouseenter' ? addMarker(lat, long) : delMarker();
                    })
                    item.addEventListener('mouseleave', () => {
                            delMarker();
                    })
                })

                let addMarker = function(lat, long) {
                    self.markerMouseEvent = [parseFloat(long), parseFloat(lat)]
                    self.showMarkerMouseEvent = true

                }

                let delMarker = function() {
                    self.showMarkerMouseEvent = false
                }

                //refresh map on layout change
                let mapResizes = document.querySelectorAll('.mapResize')
                mapResizes.forEach(mapResize => {
                    mapResize.addEventListener('click', () => {
                        setTimeout(() => {
                            var map = this.$refs.map.$map;
                            map.updateSize()
                            // this.$refs.mapView.$view.fit(this.$refs.vectorSource.$source.getExtent(), {
                            //     size: this.$refs.map.$map.getSize(),
                            //     padding: [30, 30, 30, 30],
                            //     duration: 1000,
                            // })
                        }, 1000) 
                    })
                })
            })
            .catch(error => console.error(error))
        }
    },
    watch: {
        query(val, oldVal) {
            // console.log(val, oldVal)
            this.onMapMounted()
        }
    },
    template: `
    <div class="mapPrestas">
        <vl-map ref="map" data-projection="EPSG:4326" @mounted="bindInfoWindowInfoBox">
            <vl-view ref="mapView" :zoom.sync="zoom" :center.sync="center"></vl-view>
            <vl-layer-tile>
                <vl-source-osm />
            </vl-layer-tile>
            <vl-layer-vector>
                <vl-source-vector ref="vectorSource">
                    <vl-feature v-for="(marker, i) in markers" :key="i" :id="marker.idPrestation" :properties="{ infoHtml: marker.infoHtml }">
                        <vl-geom-point :coordinates="[parseFloat(marker.longitude), parseFloat(marker.latitude)]"></vl-geom-point>
                        <vl-style-func :factory="styleFuncFactory" />
                    </vl-feature>
                    <vl-feature ref="vectorMouseEvent" v-if="showMarkerMouseEvent">
                        <vl-geom-point :coordinates="markerMouseEvent"></vl-geom-point>
                        <vl-style-box>
                            <vl-style-icon :src="mapIconOn" :scale="1" :anchor="[0.5, 1]"></vl-style-icon>
                        </vl-style-box>
                    </vl-feature>
                </vl-source-vector>
            </vl-layer-vector>
            <!-- interactions -->
            <vl-interaction-select :features.sync="selectedFeatures">
                <!-- select styles -->
                <vl-style>
                    <vl-styleStroke color="#423e9e" :width="7" />
                    <vl-styleFill :color="[254, 178, 76, 0.7]"/>
                    <vl-styleCircle :radius="5">
                        <vl-styleStroke color="#423e9e" :width="7"/>
                        <vl-styleFill :color="[254, 178, 76, 0.7]"/>
                    </vl-styleCircle>
                </vl-style>
                <vl-style :z-index="1">
                    <vl-styleStroke color="#d43f45" :width="2"/>
                    <vl-styleCircle :radius="5">
                        <vl-styleStroke color="#d43f45" :width="2"/>
                    </vl-styleCircle>
                </vl-style>
                <!--// select styles -->
                <!-- https://github.com/ghettovoice/vuelayers/issues/80 -->
                <!-- selected marker popup -->
                <vl-overlay
                    v-for="feature in selectedFeatures"
                    :key="feature.id"
                    :id="feature.id"
                    class="marker-popup"
                    :position="[parseFloat(feature.properties.longitude),parseFloat(feature.properties.latitude)]"
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                    positioning="bottom-center">
                        <div class="vl-popup"><button class="vl-popup-closer" @click="selectedFeatures = selectedFeatures.filter(f => f.id !== feature.id)"></button>
                            <div class="vl-popup-content" v-html="feature.properties.infoHtml"></div>
                        </div>
                </vl-overlay>
                <!--// selected popup -->
            </vl-interaction-select>
        </vl-map>
    </div>`
}

// <div style="padding: 20px">
//     Zoom: {{ zoom }}<br>
//     Center: {{ center }}<br>
//     My geolocation: {{ geolocPosition }}
// </div>